import { render, staticRenderFns } from "./KT-TableColumnEdit.vue?vue&type=template&id=f77d4208&scoped=true&lang=pug&"
import script from "./KT-TableColumnEdit.vue?vue&type=script&lang=js&"
export * from "./KT-TableColumnEdit.vue?vue&type=script&lang=js&"
import style0 from "./KT-TableColumnEdit.vue?vue&type=style&index=0&id=f77d4208&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f77d4208",
  null
  
)

export default component.exports